const en = {
    "KindalyChoose": "Kindly choose your product subset from the list below",
    "ViewHelp": "View Help",
    "HideHelp": "Hide Help",
    "Reset": "Reset",
    "MySolutions": "My Solutions",
    "Features": "Features",
    "YourConfigurationNotCompleted": "Your configuration is not yet completed. Please select your features.",
    "Parts": "Parts",
    "Accessories": "Accessories",
    "Results": "Results",
    "GoBack": "Go Back",
    "BranchBreaker": "Branch Breaker",
    "OptionalUsedMultipleTimes": "(Optional & can be used multiple times)",
    "RemovedItems": "Removed Items",
    "ExceededLimitOfBreaker": "You have exceeded the limit to add Branch breaker.",
    "MaxBranchBreaker": "Max 5 Branch breaker allowed.",
    "Select": "Select",
    "Discard": "Discard",
    "AddToCart": "Add To Cart",
    "Add": "Add",
    "MainBreaker": "Main Breaker",
    "CatelogDetails": "Catelog Details",
    "Datasheet": "Datasheet",
    "Close": "Close",
    "Press": "Press",
    "toExit": "to Exit",
    "MoreAccessories": "More Accessories",
    "QOFeederBreakers": "QO Feeder Breakers",
}

const fr = {
    "KindalyChoose": "Veuillez choisir votre sous-ensemble de produits dans la liste ci-dessous",
    "ViewHelp": "Voir aide",
    "HideHelp": "Masquer l'aide",
    "Reset": "Réinitialiser",
    "MySolutions": "Mes solutions",
    "Features": "Caractéristiques",
    "YourConfigurationNotCompleted": "Votre configuration n'est pas encore terminée. Veuillez sélectionner vos fonctionnalités.",
    "Parts": "les pièces",
    "Accessories": "Accessoires",
    "Results": "Résultats",
    "GoBack": "Retourner",
    "BranchBreaker": "Coupe-branches",
    "OptionalUsedMultipleTimes": "(Facultatif et peut être utilisé plusieurs fois)",
    "RemovedItems": "Éléments supprimés",
    "ExceededLimitOfBreaker": "Vous avez dépassé la limite pour ajouter un disjoncteur de branche.",
    "MaxBranchBreaker": "Max 5 disjoncteurs de dérivation autorisés.",
    "Select": "Sélectionner",
    "Discard": "Jeter",
    "AddToCart": "Ajouter au panier",
    "Add": "Ajouter",
    "MainBreaker": "Disjoncteur principal",
    "CatelogDetails": "Détails du catalogue",
    "Datasheet": "Fiche de données",
    "Close": "Fermer",
    "Press": "Presse",
    "toExit": "pour quitter",
    "MoreAccessories": "Plus d'accessoires",
    "QOFeederBreakers": "Disjoncteurs d'alimentation QO",
}


export function translateFun(key) {
    const lang = localStorage.getItem("lang") ? localStorage.getItem("lang")?.split("_")[0] : "en"
    const getLang = lang?.toLowerCase() === "fr" ? fr : en 
    const getTransKey = getLang[key] 
    return  getTransKey 
}
